export function PageHero({ eyebrow, title, subtitle, children }) {
  return (
    <section className="relative overflow-hidden hero-glow border-b border-[var(--line)]">
      <div aria-hidden="true" className="absolute -top-24 -right-24 w-96 h-96 bg-[var(--blue)]/10 blob" />
      <div aria-hidden="true" className="absolute -bottom-24 -left-24 w-80 h-80 bg-[var(--honey)]/20 blob" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-10 py-20 lg:py-28">
        <p className="eyebrow mb-5">★ {eyebrow}</p>
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.98] max-w-4xl text-[var(--blue-ink)]">
          {title}
        </h1>
        {subtitle && <p className="mt-7 text-lg text-[var(--ink-soft)] max-w-2xl leading-relaxed">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}
